import { createClient, type SupabaseClient } from "@supabase/supabase-js";

// Singleton Supabase client for the global ranking (Etapa 2b).
//
// Defensive: if the env vars are missing (e.g. a dev clone without a local
// .env), we export `null` instead of throwing. Callers treat null as "global
// ranking inactive" and fall back to an empty state — the game never crashes
// because credentials weren't set up.
//
// Only the anon PUBLIC key is ever used here. The service_role key must never
// reach the client bundle.

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

let client: SupabaseClient | null = null;

if (url && anonKey) {
  try {
    client = createClient(url, anonKey, {
      auth: { persistSession: false, autoRefreshToken: false }
    });
  } catch (error) {
    // Never fatal — leave the global ranking inactive and log for Eruda.
    console.error("[supabaseClient] No se pudo inicializar el cliente:", error);
    client = null;
  }
} else {
  console.warn("[supabaseClient] Faltan VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY — ranking global inactivo.");
}

export const supabase = client;
